// VariableContext.jsx

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { io } from "socket.io-client";

const VariableContext = createContext();
const CONFIG = require("./config.json");
const parser = require("./parser");
parser.configure(CONFIG);

export const useVariables = () => useContext(VariableContext);

export const VariableProvider = ({ children }) => {
  const [variables, setVariables] = useState({});
  const socketRef = useRef(null);

  useEffect(() => {
    console.log("variable context starting socket");

    console.log(process.env.REACT_APP_SOCKET_URL);
    

    const socket = io(process.env.REACT_APP_SOCKET_URL, {
      path: "/socket.io",
      transports: ["websocket"],
    });

    console.log('socket created');
    socket.on("connect", () => console.log("✅ connect", socket.id, "transport", socket.io.engine.transport.name));
    socket.io.engine.on("upgrade", (t) => console.log("⬆️ upgraded to", t.name));
    // socket.onAny((event, ...args) => console.log("📩", event, args?.[0]));

    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("🔌 Подключено к серверу");
    });

    socket.on("ping", (data) => {
      // console.log("ping:", data);
    });

    socket.on("init", (vars) => {
      setVariables(vars);
    });

    socket.onAny((event, ...args) => {
      // console.log(`${event}:`, args);
    });

    // socket.on("var", ({ name, value }) => {
    //   setVariables((prev) => ({
    //     ...prev,
    //     [name]: value,
    //   }));
    // });

    socket.on("logs", async ({ log, line }) => {
      // console.log("logs:");
      try {
        if (!parser.valid_log(log)) {
          console.warn(`⚠️ logs: неизвестный лог "${log}"`);
          return;
        }

        const parsed = parser.parseBySpec(line, log);
        // console.log(parsed);

        const { values } = parsed;
        if (values) {
          // for (const [name, value] of Object.entries(values)) {
          //   setVariables((prev) => ({
          //     ...prev,
          //     [name]: value,
          //   }));
          // }
          setVariables((prev) => {
            const next = {
              ...prev,
              ...values,
            };

            next.fitSum =
              Number(next.fit1 ?? 0) +
              Number(next.fit2 ?? 0) +
              Number(next.fit3 ?? 0) +
              Number(next.fit4 ?? 0) +
              Number(next.fit5 ?? 0);
            // console.log(next.fitSum);
            return next;
          });
        }
      } catch (err) {
        console.error("Ошибка logs:");
        // console.error("Ошибка logs:", err);
      }
    });

    socket.on("tf_base", (data) => {
      console.log("tf_base:", data);

      setVariables((prev) => ({
        ...prev,
        tf1_base: data.tf1,
        tf2_base: data.tf2,
        tf3_base: data.tf3,
        tf4_base: data.tf4,
        tf5_base: data.tf5,
        tf_sum_base: (data.tf5+data.tf4+data.tf3+data.tf2+data.tf1),
        tf_base_date: data.date,
      }));
    });

    socket.on("tf_day_delta", (data) => {
      console.log("tf_day_delta:", data);

      setVariables((prev) => ({
        ...prev,
        tf1_day: data.tf1,
        tf2_day: data.tf2,
        tf3_day: data.tf3,
        tf4_day: data.tf4,
        tf5_day: data.tf5,
        tf_sum_day: (data.tf5+data.tf4+data.tf3+data.tf2+data.tf1),
        tf_day_date: data.date,
      }));
    });

    socket.on("tf_prev_day", (data) => {
      console.log("tf_prev_day:", data);

      setVariables((prev) => ({
        ...prev,
        tf1_prev_day: data.tf1,
        tf2_prev_day: data.tf2,
        tf3_prev_day: data.tf3,
        tf4_prev_day: data.tf4,
        tf5_prev_day: data.tf5,
        tf_sum_prev_day: (data.tf5+data.tf4+data.tf3+data.tf2+data.tf1),
        tf_prev_day_date: data.date,
        tf_prev_day_prev_date: data.prev_date,
      }));
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <VariableContext.Provider value={{ variables }}>
      {children}
    </VariableContext.Provider>
  );
};
